import React from "react";
import DropDownLink from "./DropDownLink";

class FilterDropDown extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            isDropDownOpen: false
        };
    }

    handleMouseEnter = () => {
        this.setState({
            isDropDownOpen: true
        });
    };

    handleMouseLeave = () => {
        this.setState({
            isDropDownOpen: false
        });
    };

    handleClick = () => {
        this.setState((prevState) => ({
            isDropDownOpen: !prevState.isDropDownOpen
        }));
    };

    render() {
        const { isDropDownOpen } = this.state;
        const { btnText, links, resourcesLink } = this.props;
        const containerClasses = isDropDownOpen
            ? "filter filter__dropdown filter__dropdown-active"
            : "filter filter__dropdown";
        const dropDownLinks = links.map((link, index) => {
            const key = `${link.title} ${index + 1}`;
            return <DropDownLink key={key} resourcesLink={resourcesLink} link={link} />;
        });
        return (
            <div onMouseEnter={this.handleMouseEnter} onMouseLeave={this.handleMouseLeave} className={containerClasses}>
                <button type="button" onClick={this.handleClick}>
                    {btnText}
                </button>
                <div className="dropdown__body">{isDropDownOpen && dropDownLinks}</div>
            </div>
        );
    }
}

export default FilterDropDown;
